const attributions = [
    {
        icon: "Html5 Icon",
        iconLink: "https://iconscout.com/icons/html5",
        contributor: "Icon Mafia",
        contributorLink: "https://iconscout.com/contributors/icon-mafia",
        site: "IconScout",
        siteLink: "https://iconscout.com"
    },
    {
        icon: "Css Icon",
        iconLink: "https://iconscout.com/icons/css",
        contributor: "Icon Mafia",
        contributorLink: "https://iconscout.com/contributors/icon-mafia",
        site: "IconScout",
        siteLink: "https://iconscout.com"
    },
    {
        icon: "Javascript Icon",
        iconLink: "https://iconscout.com/icons/javascript",
        contributor: "Icon 54",
        contributorLink: "https://iconscout.com/contributors/icon-54",
        site: "IconScout",
        siteLink: "https://iconscout.com"
    },
    {
        icon: "React Icon",
        iconLink: "https://iconscout.com/icons/react",
        contributor: "Icon Mafia",
        contributorLink: "https://iconscout.com/contributors/icon-mafia",
        site: "IconScout",
        siteLink: "https://iconscout.com"
    },
    {
        icon: "Node Js Icon",
        iconLink: "https://iconscout.com/icons/node-js",
        contributor: "Icon Mafia",
        contributorLink: "https://iconscout.com/contriconibutors/icon-mafia",
        site: "IconScout",
        siteLink: "https://iconscout.com"
    },
    {
        icon: "Mongodb Icon",
        iconLink: "https://iconscout.com/icons/mongodb",
        contributor: "Icon Mafia",
        contributorLink: "https://iconscout.com/contributors/icon-mafia",
        site: "IconScout",
        siteLink: "https://iconscout.com"
    },
]

export default attributions;